module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CH-T"
  }, [_vm._v("Essential Equipment")]), _vm._v(" "), _c('p', {
    staticClass: "CH-INTRO1"
  }, [_vm._v("If you are already a keen beader or craft person, much of the equipment and many of the materials listed are things that you will generally have in your workbox. You don’t need to get everything at once as you can always improvise, but for best results it is better to use a similar material or the equipment and tools listed.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD",
    attrs: {
      "id": "Cords-and-Threads"
    }
  }, [_vm._v("Cords and Threads")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("Knotting and braiding techniques can be worked in a huge variety of different threads and cords. The choices available are reviewed in this section, and for information about the most popular cords and threads used for Kumihimo see "), _c('span', {
    attrs: {
      "href": "#/c11#CORDS-AND-THREADS-FOR-KUMIHIMO",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cords and Threads for Kumihimo")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("CHOOSING CORDS")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Once you have learnt a technique, do experiment with different materials as you will be surprised at the results. Knots can lose definition when worked with a soft cord such as satin rattail or embroidery cottons, and the shape can be much more distinct when a stiffer cord such as Superlon™, wax cotton, or round leather thong is used. Before you start, consider how you want the finished item to look and choose your cord or thread accordingly. Remember that each of these cords are available in a range of thicknesses and can be worked singly or in multiple bundles.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/knottingthreads_fmt.jpg"
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "DHD"
  }, [_vm._v("Cord guide")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("This sample board of cords shows at a glance some of the cords that are suitable for knotting and braiding and gives you a quick guide to the range of thicknesses available in the different cords.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/9_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Satin cord (rattail)")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("This silky cord has a high sheen and is available in a range of thicknesses: bugtail is 1mm thick, mousetail 1.5mm thick, and rattail is 2mm thick, however, in practice all tend to be called rattail now. The cord is quite soft so it doesn’t support the shape of knots very well and it isn’t very hard-wearing.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Chinese knotting cord")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("This nylon braided cord holds its round shape when it is worked. Currently available in 0.4–3mm, the thicker cords are particularly suitable for knotting techniques. Finer cords are popular for macramé and Shamballa-style bead bracelets. Look online for the widest colour ranges, but you will find that the choice of colour for the thicker cords is not as extensive.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Wax cotton cord")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Wax cotton cord is suitable for a range of techniques. Look out for thicker 3mm cord, which works particularly well for individual knots and knotted braids as it holds its shape well. Thinner wax cotton is ideal for macramé and easy to string with beads. They are available in natural shades and a range of colours, many of which follow current fashion trends.")]), _vm._v(" "), _c('div', {
    staticClass: "SBDIV"
  }, [_c('h4', {
    staticClass: "TIP-AHD"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "TIP1"
  }, [_vm._v("If wax cotton cord softens from overuse or you want to reuse a length, pull through under a medium hot iron to smooth kinks and restore the finish.")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Superlon™")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Superlon™ (often abbreviated to S-lon™) is an industrial strength twisted nylon cord originally used for upholstery. It is available in 0.5mm and 0.9mm widths and both are suitable for micro macramé and other knotting techniques where you want a fine braid or finish. These cords are perfect for adding beads into your knotting or braiding and can be mixed with thicker cords for a change of texture. Both sizes are available in a range of neutrals and pretty contemporary colours.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Paracord")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("This chunky cord is commonly available in two thicknesses: paracord 550 (4mm) has seven strands down the centre and paracord 450 (2mm) has four centre strands. Paracord is perfect for making bracelets and other accessories from single knots and single width knotted braid, and as it is quite bulky, it is popular for men’s jewellery. The cord is available in a wide range of solid bright and dark colours as well as in many multicoloured patterns.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Leather thong")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Round leather thong makes a good distinct knot as it is a firm cord. It is available in a range of thicknesses from around 0.5mm up to 6mm. The thinner cords are good for tying knots and the thicker cords more suitable for use as a core to tie the knots around. Leather thong is available in natural shades and a wide range of colours. Pearlescent finishes, usually in pale pastels, are particularly attractive as are the different thicknesses of snakeskin effect cords.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Faux suede")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("This flat microfibre cord looks like real leather suede, but is much more pliable than the real thing and gives a completely different look to knots or knotted braids. It is generally 3mm wide and available in a range of colours.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Embroidery threads")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Stranded cotton and cotton perlé are just two readily available threads that can be used for knotting, plaiting and braiding. Embroidery threads are soft and won’t hold the shape of a knot firmly but they look good when combined with stiffer cords. The colour range is much greater than for other cords, so exciting colour schemes are possible. While embroidery threads are usually matte, you can use metallic embroidery threads to add a touch of sparkle.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD",
    attrs: {
      "id": "Wire"
    }
  }, [_vm._v("Wire")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("Wire is not often used for knotting techniques because it is difficult to tie the wire without it getting kinked, although some knots created with more of a wrapping technique, such as the pipa knot, can be worked in wire. Wire, especially bundles of finer wire, can be used successfully for any Kumihimo braid, and it is also used for some finishing techniques for knotting and braiding (see "), _c('span', {
    attrs: {
      "href": "#/c08#Finishing-Techniques-for-Knotting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finishing Techniques for Knotting")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/c11#Finishing-Techniques-for-Braiding",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Finishing Techniques for Braiding")]), _vm._v("). For more information about using wire for Kumihimo see "), _c('span', {
    attrs: {
      "href": "#/c11#CORDS-AND-THREADS-FOR-KUMIHIMO",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cords and Threads for Kumihimo")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("CHOOSING WIRE")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Wire used for knotting and braiding techniques needs to resist breaking even when it is bent back and forwards several times. Most craft wires have a copper core that makes them suitable but you can experiment with all sorts of wire. The main jewellery wires are reviewed here but remember that two or more thinner wires are easier to manipulate than one thick wire.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/DSC_7397_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Copper wires")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("As it is an inexpensive material, copper wire is suitable for experimenting with for both knotting and braiding techniques. Most craft wires have a copper core with the colours enamelled and the metallic finishes plated. You don’t often get a choice of hardness with copper craft wires but I have found that those sold specially for crochet or knitting are softer and less prone to snap. Remember, also, that thinner wires are easier to manipulate than thicker wires.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Silver wire")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Although expensive, silver wire will elevate any jewellery project to another level. It is available in a range of thicknesses, with soft, half-hard and hard being the most common, as well as different cross sections such as round, square, rectangular and D-shaped. Choose a soft condition wire as it is easier to work – you’ll find that even half-hard wire is more difficult to work.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Coated wires")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("It is worth experimenting with coated wires, either paper, plastic or wrapped with fine thread, as these are less prone to kink and you can get surprising results.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Aluminium wire")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Aluminium wire can be thicker than copper core wires as it is much softer, but use nylon-jaw pliers wire to prevent the wire getting damaged.")]), _vm._v(" "), _c('div', {
    staticClass: "SBDIV"
  }, [_c('h4', {
    staticClass: "TIP-AHD"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "TIP1"
  }, [_vm._v("Twisting a double length of thinner wire together using a pencil or small hand drill (cord winder) makes the wire less prone to kink so making it easier to manipulate into a knot or braid than the equivalent thicker wire.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/TwistingWire_5_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('h5', {
    staticClass: "DHD"
  }, [_vm._v("Wire gauges")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Wires are available in a range of thicknesses or gauges and sold by millimetre, standard wire gauge (swg) or American wire gauge (awg). Several strands of a 0.315mm (30 swg) wire is good for Kumihimo and a 0.6mm (24swg) ideal for finishing jewellery with a plain or wrapped loop (see "), _c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("General Techniques")]), _vm._v("). You’ll notice that the thinner the wire, the higher the swg or awg.")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "TD-BHD"
  }, [_vm._v("mm")]), _vm._v(" "), _c('td', {
    staticClass: "TD-BHD"
  }, [_vm._v("swg")]), _vm._v(" "), _c('td', {
    staticClass: "TD-BHD"
  }, [_vm._v("awg")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "TD-L"
  }, [_vm._v("0.2")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("36")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("32")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "TD-L"
  }, [_vm._v("0.25")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("33")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("30")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "TD-L"
  }, [_vm._v("0.315")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("30")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("28")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "TD-L"
  }, [_vm._v("0.4")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("27")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("26")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "TD-L"
  }, [_vm._v("0.5")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("25")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("24")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "TD-L"
  }, [_vm._v("0.6")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("24")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("22")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "TD-L"
  }, [_vm._v("0.7")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("22")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("21")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "TD-L"
  }, [_vm._v("0.8")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("21")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("20")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "TD-L"
  }, [_vm._v("0.9")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("20")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("19")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "TD-L"
  }, [_vm._v("1.00")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("19")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("18")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "TD-L"
  }, [_vm._v("1.2")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("18")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("16")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "TD-L"
  }, [_vm._v("1.5")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("16")]), _vm._v(" "), _c('td', {
    staticClass: "TD-L"
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("Beads")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("Beads can be added to all the knotting and braiding techniques in a variety of different ways, either during braiding or knotting or afterwards. For more information see "), _c('span', {
    attrs: {
      "href": "#/c07#Beaded-Knotted-Braids",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beaded Knotted Braids")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/c11#Beaded-Kumihimo-Braids",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beaded Kumihimo Braids")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("CHOOSING BEADS")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Beads come in all sorts of colours, finishes, sizes and shapes, but for knotting and braiding the size of hole is paramount so the beads can be easily strung onto the cord. It is a good idea to take a sample of cord with you when you go bead shopping.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/beads1_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Seed beads")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("This is a generic term used to describe the tiny glass beads used primarily for bead stitching and stringing. Basic seed beads (rocailles) are doughnut shaped, and the most common sizes are 15 to 3 (1–5.5mm) with 15 (1mm) being the smallest; cylinder-shaped beads, also known as delicas or magnificas, have larger holes and the double delicas can be strung onto 1mm cord. Look out too for unusual textures like the triangle, hex or charlotte beads, or for different shapes such as papillon (or peanut) beads and magatamas (drop beads).")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Large beads")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("There are so many different beads that can be used in braiding techniques from simple wood beads to exquisite pearls and crystals, and the choice is yours. Bead hole size need not necessarily restrict you as some beads have surprisingly large holes, such as the Swarovski Mini-bead range, where even the 6mm beads fit onto 1mm cord. Pandora-style beads have very large holes and will fit over 6mm cord.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Focal beads")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These extra large beads are often used as a focal point for a piece of jewellery. You can suspend pendant beads onto braids using a bail, or attach cords to large ring beads to work macramé or other knotting techniques. Remember too that large beads can be attached between two lengths of braid that have been finished with end caps.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("Findings")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("Findings are all the little pieces, generally made from metal, that are used to make and finish items of jewellery or other accessories. Many of the findings are used to cover the raw ends of cords or braids and it is important to choose the correct size and shape. Keep a good selection of findings in your workbox so that you can create and finish different pieces.")]), _vm._v(" "), _c('h5', {
    staticClass: "DHD",
    attrs: {
      "id": "Finishing-ends"
    }
  }, [_vm._v("Finishing ends")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These findings are used to finish the ends of braids and knotted cords. There are more and more styles being manufactured year on year and most are available in a range of metallic finishes. For best results, match the measurement of the internal dimensions of the finishing ends to the cord or braid. Some finishing ends incorporate a fastening but if this is not the case, see "), _c('a', {
    attrs: {
      "href": "#/c01#Jewellery-fastenings"
    }
  }, [_vm._v("Jewellery fastenings")]), _vm._v(" for your options.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Cord ends")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Used to finish single cords, some styles have lugs that you secure over the cord with pliers, others are tubular and are either secured with glue or with an integral crimp ring.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/12-cords-ends_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Spring ends")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("One of the older styles of finding, these can be cylindrical or cone shaped. Tuck the cord or braid inside the wire coil, then use pliers to squeeze only the end ring to secure.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/12-spring-ends_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("End cones")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These cone or bell-shaped findings can either have a hole at the top or be finished with a loop. For best results use jewellery glue to secure the braid into both styles (see "), _c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("General Techniques")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture-022_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("End caps")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("End caps are cylindrical, square or rectangular versions of end cones, and they too either have a hole at the top or are ready-finished with a ring or loop. For best results use jewellery glue to secure the braid into both styles, and you will find information on how to add a plain or wrapped loop in "), _c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("General Techniques")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/endcaps_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Ribbon crimps")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("As the name suggests, these are designed to cover the raw end of ribbon, but they can be used to finish flat braids or cord. To prevent it from getting damaged, use nylon-jaw pliers to close the ribbon crimp over the braid.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/ribboncrimps_fmt.jpg"
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "DHD"
  }, [_vm._v("Basic jewellery findings")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These are the basic components of many styles of jewellery. All findings are now available in a range of different metallic finishes including antique, so choose the most suitable colour to match or contrast with your braid.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Jump rings")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Round or oval, these rings can be opened and closed with flat-nose pliers, and they are used to connect items or attach other findings or fastenings. The smaller rings, 4–6mm, are less likely to pull open than larger rings.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/DSC_7356_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Split rings")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These are made from a hard metal coil (like a key ring), so they are more secure than a jump ring. Use split-ring pliers to prise them open to attach them to other findings.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/DSC_7358_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Headpins")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These straight wire findings are used to make bead dangles with a plain or wrapped loop (see "), _c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("General Techniques")]), _vm._v("). They have a plain or decorative end to stop beads falling off and come in different lengths. Soft wire headpins are easier to manipulate.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/DSC_7354_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Eyepins")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These are straight pieces of wire of different lengths with a round loop at one end. They are used mainly to make bead links or to create a loop with an end cap attached at the end of braid.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/DSC_7346_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Crimps")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Generally used with bead stringing wire, these tiny doughnut shapes or tubes are secured with crimp pliers or can simply be flattened with flat-nose pliers. They are used on single wire to space beads or on doubled wire to secure to a jump ring or fastening.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/DSC_73781_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Calottes")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Sometimes called bead tips, these little domed findings are used to neatly attach fastenings when stringing beads. The basic calotte has a notch in one dome; for extra security choose a clamshell calotte that has the hole in the hinge.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture-012_fmt.jpg"
    }
  })]), _vm._v(" "), _c('h5', {
    staticClass: "DHD",
    attrs: {
      "id": "Jewellery-fastenings"
    }
  }, [_vm._v("Jewellery fastenings")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("There are lots of different findings used to finish pieces of jewellery such as necklaces, bracelets, earrings and rings. I’ve chosen a few styles of fastenings suitable for using with knotting and braiding. Some of the fastenings are end caps (see "), _c('a', {
    attrs: {
      "href": "#/c01#Finishing-ends"
    }
  }, [_vm._v("Finishing ends")]), _vm._v(") with a magnetic fastening incorporated in the design; otherwise, choose a style that matches the end cap and complements the braid in colour and weight.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Toggle fastening")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("This two-part fastening has a T-bar and ring; turn the T-bar on its side to slot in or out of the ring. Choose a more decorative style as a design feature.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/13-toggle-fastening_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Magnetic fastenings")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These neat fastenings have a very strong magnet incorporated in the design. They are perfect for finishing necklaces and bracelets. If you are worried about the clasp pulling apart, add a safety chain.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/13-magnetic-fastenings_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Trigger clasp")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("This inexpensive fastening with a spring closure is suitable for finishing both bracelets and necklaces. Available styles include the lobster claw and bolt ring.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture-037_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Multi-strand clasps")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These are available in a range of styles. The box shape is suitable for necklaces and the slider fastening is ideal for macramé and other cuff-style bracelets. Choose the number of rings on each side to suit the project.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture-103_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Plastic clasps")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These plastic clasps are specially designed for knotting techniques such as macramé as they have a bar end to attach the cords to. The clasps are available in a range of sizes and a variety of bright colours.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/plasticclasps_fmt.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("Tools")]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("Aside from Kumihimo, knotting and braiding techniques require little in the way of specialist equipment, indeed it is likely that most beaders or crafters will have any tools needed in their workbox already, so you should be able to get going straight away. Refer to "), _c('span', {
    attrs: {
      "href": "#/c11#Equipment-and-Materials",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kumihimo: Equipment and Materials")]), _vm._v(" for information about what you need to get started with Kumihimo.")]), _vm._v(" "), _c('h5', {
    staticClass: "DHD"
  }, [_vm._v("Jewellery Tools")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("A basic set of three tools is needed to turn braids or knotting into jewellery. It is always worth buying good-quality, fine tools as these will help you to finish things in a neat and professional way, but avoid mini-tools as these will make your hands sore if used for long periods.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/14_15-tools_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Wire cutters (1)")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("I usually spend a little more on wire cutters as these make life much easier. Choose side cutters, or preferably flush cutters, that cut a straight end on wire or headpins. Remember to cut with the flat side of the cutters towards the work or facing away from the tail.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Round-nose pliers (2)")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These pliers are used to make loops with wire or headpins. The jaws are cone-shaped so you can vary the size of the loops by working near the top of the jaws for small loops and near the bottom for larger loops. To make loops the same size, always work the same distance down; I generally work about 6mm ("), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("in) from the top of the pliers.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Flat-nose pliers (3)")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These are used for manipulating wire and headpins, or for opening and closing jump rings. Always look for fairly smooth surfaces on the inside of the jaws – pliers from the local hardware store are unsuitable as apart from being too big, they will probably have deep serrations for grip, which will damage the wire. Blunt-end pliers are the workhorse tool but snipe-nose (chain-nose) pliers with tapered jaws allow you to get in closer.")]), _vm._v(" "), _c('h5', {
    staticClass: "DHD"
  }, [_vm._v("Specialist tools")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Although not essential, this kit will help you to finish jewellery in a professional manner, so consider making the investment if you can.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Bent-nose pliers")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These are essentially snipe-nose pliers with a right-angle bend in the jaws, allowing you to get into awkward positions and to hold wire or headpins at a more comfortable angle as required.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Nylon-jaw pliers (4)")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These pliers have a softer material covering the metal jaws to prevent damage to softer wires and findings. They are available as round-nose or flat-nose pliers.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Crimp pliers")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Available in a three sizes – micro, regular and macro – these pliers are used to close crimps neatly around bead stringing wire in particular. Match the pliers to the thickness of wire and crimp size.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Split-ring pliers")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("With a specially-designed tip for opening split-rings, these will definitely help prevent broken nails!")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Awl (5)")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("An awl is useful for pushing and easing cords and braids into metal findings.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Warp posts (6)")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Clamp over the edge of the work surface and set a particular distance apart for winding long lengths of cord.")]), _vm._v(" "), _c('h5', {
    staticClass: "DHD"
  }, [_vm._v("Other essentials")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("You might find these items in your toolbox already; they will be useful when knotting and braiding.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Scissors")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Keep two or three different sizes of scissors specially for cutting threads and cord and don’t use them for cutting paper as this will blunt the blades very quickly. Medium scissors are ideal for cutting thread and cords to length and small embroidery scissors with sharp points are perfect for trimming ends neatly.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Needles")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("There are all sorts of needles that can make it easier to finish braids and knotting or thread beads.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/16-needles_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('strong', [_vm._v("Sewing needles (A)")]), _vm._v(" A selection of different sized sewing needles will allow you to sew through braids or secure ends after wrapping. Sharps have a small eye but are quite sturdy and can be used to stitch small seed beads into tougher cords. Embroidery needles have longer eyes to make them easier to thread.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST2"
  }, [_c('strong', [_vm._v("Tapestry needles (B)")]), _vm._v(" These have a relatively blunt tip and large eye and are useful for stringing bigger beads onto cord or for manoeuvring knots into position.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST2"
  }, [_c('strong', [_vm._v("Beading needles (C)")]), _vm._v(" Fine beading needles are used to add seed beads and other small beads to braids or to cover joins. A size 10 needle is ideal for size 11 seed beads and a size 12 or 13 for size 15 seed beads. Keep a good stock as the finer needles in particular can bend and break.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST2"
  }, [_c('strong', [_vm._v("Twisted wire needles (D)")]), _vm._v(" You can make your own needles by looping fine wire over the jaws of round-nose pliers and twisting the tails together. Alternatively, they can be bought in a range of sizes to string beads onto cord or thread or to pull thread or cords through braids to work or neaten ends.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST2"
  }, [_c('strong', [_vm._v("Big eye needles (E)")]), _vm._v(" These long needles with two pointed ends are useful for stringing beads onto multi-strands of fine threads, but avoid using to pull cords through a tight space as the two fine rods that make the needle will split apart at the soldered end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Pins")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('strong', [_vm._v("Dressmaker’s pins")]), _vm._v(" Useful for marking braids at a particular length, for spacing beads or embellishments, or to position wrapped threads.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pins_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST2"
  }, [_c('strong', [_vm._v("Map pins")]), _vm._v(" These short pins with ball ends are perfect for securing cords and threads when working macramé. Pin into a cork board or sheet of foam core.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/mappins_fmt.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Adhesives")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("There are a range of different glues that will come in useful for sticking cords and threads, and for making jewellery and other accessories. Choose the correct adhesive to suit the materials you are sticking and remember to leave for 24 hours for the glue to set properly before using.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Jewellery")]), _vm._v(" "), _c('strong', [_vm._v("glue")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Glues such as G-S Hypo Cement and E6000 are specially made for jewellery. The glue sets but stays pliable so that it is less prone to crack and break off over time. The G-S Hypo Cement has a fine nozzle ideal for applying a tiny amount for a neat finish, otherwise use a cocktail stick to apply the glue.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Superglue")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("These instant glues can be useful as you don’t need to hold the material in position until the glue sets. The gel version is less likely to run and it’s easier to be accurate and apply a tiny amount. Take care as these cyanoacrylate glues will bond skin.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_c('strong', [_vm._v("Epoxy resin")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("A two-part adhesive that is very good for sticking cords into metal findings. Wipe surfaces with nail polish remover to remove greasy fingerprints before you apply the adhesive. A 5-minute epoxy resin shortens the drying time and one that dries clear is less likely to be visible when used.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6d370bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c01.vue
// module id = 66
// module chunks = 0